export default "__VITE_ASSET__BptzAAZB__"